import React, {
    useMemo,
    useState,
    useCallback,
    useRef,
    useEffect,  // Add useEffec
} from "react";
import {
    Modal,
    Row,
    Col,
    Navbar,
    Nav,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import { logout } from "../../utils";
import { CreatedDateRenderer } from "./K1LandingPage/K1HelperFunctions";

export const K1ChangeHistoryModal = (props) => {
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [rowData, setRowData] = useState([]);

    // Setting default grid params
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: "78vh", width: "100%" }), []);
    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    const defaultColDef = useMemo(
        () => ({
            filter: true,
            resizable: true,
            animateRows: true,
        }),
        []
    );

    const fetchK1ChangeHistoryPageData = useCallback(async () => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
        };

        setRefreshGrid(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URI}/workflow/k1/k1_change_history/?K1FileId=${props.K1FileId}`, requestOptions);

            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized error
                    logout();
                    alert("Session ended , Please login back");
                } else {
                    throw new Error("Request failed.");
                }
            }

            const data = await response.json();
            console.log(data)
            const details = data.data;

            setRowData(details);

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setRefreshGrid(false);
        }
    }, []);

    useEffect(() => {
        fetchK1ChangeHistoryPageData();
    }, []);
    

    // Declaring the api - grid connections
    const [columnDefs, setColumnDefs] = useState([
        {
            field: "KeyName",
            headerName: "Field Name",
            flex: 1
        },
        {
            field: "OldValue",
            headerName: "Old Value",
            flex: 1
        },
        {
            field: "NewValue",
            headerName: "New Value",
            flex: 1
        },
        {
            field: "CreatedBy",
            headerName: "Modified By",
            flex: 1
        },
        {
            field: "CreatedDate",
            headerName: "Modified Date",
            flex: 1,
            cellRenderer: (params) => CreatedDateRenderer(params.data["CreatedDate"])
        },
    ]);


    const CustomNoRowsOverlay = (props) => {
        return (
            <div
                className="ag-overlay-loading-center flex-row-center-center"
                style={{ height: '9%' }}
            >
                <div className="spinner " style={{ fontSize: 14, fontWeight: 500 }}>
                    {props.noRowsMessageFunc()}
                </div>
            </div>
        );
    };

    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    const noRowsOverlayComponentParams = useMemo(() => { return { noRowsMessageFunc: () => !refreshGrid ? `No data available`:`Loading your data` } }, [refreshGrid]);

    const [gridApi, setGridApi] = useState(undefined);
    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
        params.api.closeToolPanel();
    }, []);

    
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className="full-modal"
            scrollable="false"
            style={{ padding: "20px" }}
        >
            <Modal.Header className="modal-header" closeButton>
                <Navbar collapseOnSelect expand="lg" className="sticky-nav kone-nav">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto"></Nav>
                        <Row className="no-gutter flex-row-space-center" style={{ width: "100%" }}>
                            <Col md={6} className="flex-row-center-start pagey">
                                <h4>K1 Change History</h4> 
                            </Col>
                            <Col md={6} className="flex-row-center-end pagey">
                                <b>{props.FileName}</b>
                            </Col>
                        </Row>
                    </Navbar.Collapse>
                </Navbar>
            </Modal.Header>
            <Modal.Body className="modal-body">
                <Row className="no-gutter" style={{ padding: "0px" }}>
                    <div className="ag-theme-balham" style={gridStyle}>
                        <AgGridReact
                            key={refreshGrid}
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            onGridReady={onGridReady}
                            alwaysShowHorizontalScroll={false}
                            alwaysShowVerticalScroll={false}
                            rowHeight={50}
                            suppressContextMenu={true}
                            onFirstDataRendered={onFirstDataRendered}
                            noRowsOverlayComponent={noRowsOverlayComponent}
                            noRowsOverlayComponentParams={noRowsOverlayComponentParams}
                            rowSelection={'none'}
                        />
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    );
};
